import * as React from 'react'

import { cn } from '@/lib/utils'

/**
 * Renders a styled textarea element that accepts and forwards standard textarea props.
 *
 * The component applies a default set of utility classes (including accessibility and state styles)
 * and merges any provided `className` before spreading the remaining props onto the underlying element.
 *
 * @param className - Additional CSS class names to merge with the component's default classes
 * @returns A textarea React element with composed styling and all provided props applied
 */
function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
